/* eslint-disable complexity */
import format from 'date-fns/format'

import { toISO861, toISODate } from '@/utils/date'

const getDateOrNull = value =>
  !value ? null : value instanceof Date ? format(value, 'yyyy-MM-dd') : value

const getISODateOrNull = value => (value ? toISODate(new Date(value)) : null)

const getISO861OrNull = value => (value ? toISO861(value) : null)

const getTimeOrNull = value => (value ? value.split('T')[1] : null)

const parseNumberOrNull = dischargeForecastInDays => {
  const value = parseInt(dischargeForecastInDays)
  return isNaN(value) ? null : value
}

export const surgeryApiResponseToModel = data => ({
  ...data,
  hospitalizationProcedures: data.hospitalizationProcedures ?? [],
  provider: data.providerUnit ?? null,
  objectiveCodes: data.objectiveCodes ?? [],
  evolutions: data.evolutions ?? [],
  surgeryIndicationDate: getISODateOrNull(data.surgeryIndicationDate),
  admissionDate: getISODateOrNull(data.admissionDate),
  startedAtDate: getISODateOrNull(data.startedAt),
  startedAtTime: getTimeOrNull(data.startedAt),
  dischargeDate: getISODateOrNull(data.endedAt),
  daysInIntensiveCare: data.daysInIntensiveCare || []
})

const getStartedAtValue = ({ startedAtDate, startedAtTime }) => {
  if (!startedAtTime) {
    startedAtTime = '00:00'
  }
  return startedAtDate ? `${startedAtDate}T${startedAtTime}` : null
}

export const surgeryModelToAPI = model => ({
  ...model,
  dischargeSummaryEvaluation: model.dischargeSummaryEvaluation,
  dischargeForecastInDays: parseNumberOrNull(model.dischargeForecastInDays),
  providerUnitId: model.provider?.id ?? null,
  objectiveCodes: model.objectiveCodes ?? [],
  postProgramming: model.postProgramming ?? null,
  startedAt: getStartedAtValue(model),
  endedAt: getISO861OrNull(model.dischargeDate),
  admissionDate: getISO861OrNull(model.admissionDate),
  surgeryIndicationDate: getISO861OrNull(model.surgeryIndicationDate),
  status: model.status ?? null,
  surgeonId: model.surgeon?.id ?? null,
  hospitalizationProcedures:
    model.hospitalizationProcedures
      ?.filter(({ procedureDate, procedure }) => procedureDate && procedure)
      .map(({ procedureDate, procedure }) => ({
        procedureDate,
        procedureId: procedure?.id,
        procedureCode: procedure?.aliceCode
      })) || [],
  newEvolutions:
    model.evolutions?.filter(
      ({ createdAt, staffName, description }) =>
        !createdAt && !staffName && description
    ) || [],
  daysInIntensiveCare:
    model.daysInIntensiveCare
      ?.map(date => getDateOrNull(date))
      .filter(value => value !== null) || [],
  counterReferrals: model.counterReferrals ?? [],
  totvsGuias: model.totvsGuias ?? []
})
